import formatDurationLabel from '@/features/home-videos/utils/formatDurationLabel';

/**
 * The visible duration and the accessible name for a video's Watch control,
 * e.g. { duration: '1 min', watchLabel: 'Watch: Take a tour (1 min)' }.
 *
 * @param {{ title: string, durationSeconds: number|null }} video
 * @param {(key: string, options?: Object) => string} t
 */
export default function getWatchLabels(video, t) {
  const duration = formatDurationLabel(video.durationSeconds, t);
  const watchLabel = duration
    ? t('home_videos.card.watch_label', { title: video.title, duration })
    : t('home_videos.card.watch_label_no_duration', { title: video.title });
  return { duration, watchLabel };
}
